// src/utils/media.ts
var respondTo = (breakpoint) => `@media only screen and (max-width: ${breakpoint})`;
var respondMore = (breakpoint) => `@media only screen and (min-width: ${parseInt(breakpoint, 10) - 1}px)`;

export { respondMore, respondTo };
